import React, { useEffect, useState } from "react";
import "./Navbar.css";
import Logo from "../../../Assets/2logo.png";
import { useHistory, useLocation } from "react-router-dom";
import HorizontalSplitIcon from "@material-ui/icons/HorizontalSplit";
import axios from "axios";
import { MunicipalityNaneFrontSetting, nodeURL } from "../../../config";
import {
  addFeatureFromGeojson,
  showGeojson,
  showGeojsonnew,
  tempLayer,
  zoomToGeojson,
  zoomToYapiAdres,
} from "../../Map/Layers/tempLayer";
import MyMap from "../../Map/Views/MyMap";
import useDebounceState from "../../../Hooks/useDebounceState";

export default function Navbar() {
  const [arama, setArama, immediateArama] = useDebounceState("", 300);
  const [results, setResults] = useState([]);

  const history = useHistory();
  const location = useLocation();

  const routerFunc = (path) => {
    if (location.pathname === path) {
      history.push("/");
    } else {
      history.push(path);
    }
  };
  const handleResultClick = async (result) => {
    console.log("büşra 2 ");
    axios
      .get(
        MunicipalityNaneFrontSetting.nodeURL +
          "arama/hizli/get/geojson/" +
          result.oid
      )
      .then((res) => {
        const geoJSON = JSON.parse(res.data.rows[0].geojson);
        const coordinates = geoJSON.coordinates[0];
        const firstCoordinate = coordinates[0];
        setArama("");
        setResults([]);
        tempLayer.getSource().clear();
        showGeojsonnew(res.data.rows[0].geojson);
      })
      .catch((err2) => {
        console.log(err2);
      });
  };
  const onSubmitSearch = async () => {
    if (arama.length < 3) {
      return;
    }

    let json = {
      arama: arama.toLocaleUpperCase("tr-TR"),
    };
    console.log(json, "json ");
    await axios
      .post(MunicipalityNaneFrontSetting.nodeURL + "arama/hizli", json)
      .then((res) => {
        setResults(res.data.rows);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setArama(value);
  };

  useEffect(() => {
    if (arama.length < 3) {
      setResults([]);
      return;
    }

    onSubmitSearch();
  }, [arama]);

  const handleInputClear = () => {
    // Input içeriği silindiğinde, arama sonuçlarını temizle
    setArama("");
    setResults([]);
  };
  useEffect(() => {
    MyMap.addLayer(tempLayer);

    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, []);

  return (
    <>
      <div className="col-12">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="navBar d-flex align-items-center">
                <div className=" navContent">
                  <div className="col-5" style={{ marginLeft: "10px" }}>
                    <div className="d-flex d-inline align-items-center navIco">
                      <HorizontalSplitIcon
                        onClick={() => routerFunc("/adres-arama")}
                        fontSize="large"
                      />
                    </div>
                  </div>
                  &nbsp;&nbsp;
                  <input
                    type="text"
                    style={{ minWidth: "60px", display: "none" }}
                    placeholder="İlçe / Mahalle / Yol / Durak"
                    className="form-control form-control-sm textInputStyle"
                  />
                </div>
                <div
                  className="col-6"
                  style={{ position: "relative", marginLeft: "10px" }}
                >
                  <input
                    id="ara"
                    style={{
                      borderRadius: "5px",
                      backgroundColor: "whitesmoke",
                      color: "black",
                      marginLeft: "12%",
                      width: " 40%",
                      maxWidth: "50%",
                    }}
                    type="search"
                    className="inputSearch"
                    placeholder="Hızlı Arama"
                    value={immediateArama}
                    onChange={handleInputChange}
                    onInput={handleInputClear} // input içeriği silinirse bu fonksiyon çalışacak
                  />
                  <button
                    onClick={onSubmitSearch}
                    style={{ backgroundColor: "#0F3C51", border: "none" }}
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <div className="col-5">
                  <div className="appTitle">
                    <span style={{ fontSize: "1.2rem" }}>
                      Adres Bilgi Sistemi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="LogoDiv" style={{ width: "9%", minWidth: "75px" }}>
            <img src={Logo} alt="" width="100%" />
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-6" style={{ marginRight: "100%" }}>
                {results.length > 0 && (
                  <div style={{ position: "absolute" }}>
                    <div
                      style={{
                        marginLeft: "120px",
                        overflow: "auto",
                        maxHeight: "40vh",
                        width: "400px",
                        fontSize: "13px",
                      }}
                    >
                      <ul>
                        <table style={{ width: "100%" }}>
                          {results.map((d, i) => (
                            <div
                              key={i}
                              style={{
                                backgroundColor: "#0F3C51",
                                cursor: "pointer",
                                color: "wheat",
                                borderRadius: "5px",
                                border: "1px solid black",
                              }}
                              onClick={() => handleResultClick(d)}
                            >
                              <tr
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  height: "40px",
                                  alignItems: "center",
                                }}
                              >
                                <td>
                                  {d.ad}-({d.tur})-({d.iadi}/{d.madi})
                                </td>
                              </tr>
                              <div style={{ marginTop: "2px" }}></div>
                            </div>
                          ))}
                        </table>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
